export const handleSubmitExistingData = ({ values, trigger }) => {
  const finalData = {};
  Object.entries(values).forEach(([key, value]) => {
    finalData[key] = value;
  });
  trigger({ data: finalData });
};
export const handleSubmitDocuments = ({
  values,
  trigger,
  documents,
  initialValues,
}) => {
  const data = {};
  let success = false;
  documents.forEach((id) => {
    if (!values[id] || values[id] === true) {
      return;
    }
    data[id] = values[id];
  });
  if (Object.keys(data).length === 0) {
    return null;
  }
  const finalData = {};
  Object.entries(data).forEach(([key, value]) => {
    if (value === initialValues[key]) {
      return;
    }
    finalData[key] = value;
  });
  if (Object.keys(finalData).length === 0) {
    return null;
  }
  finalData.country = values.country;
  trigger({ data: finalData })
    .unwrap()
    .catch(() => {})
    .then(() => {
      success = true;
    });
  return success;
};

export const handleSubmitProfileData = ({ values, trigger }) => {
  trigger({ data: { default: values.isDefault } });
};

export const profileFormHandler = ({ values, initialValues }) => ({
  submitExistingData: (trigger) =>
    handleSubmitExistingData({ values, trigger, initialValues }),
  submitDocuments: (trigger, documents) =>
    handleSubmitDocuments({ values, trigger, documents, initialValues }),
  submitDraftData: (trigger) => trigger({ data: values }),
  submitProfileData: (trigger) => handleSubmitProfileData({ values, trigger }),
});
